import React from "react";

const VirtualBoxIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 255.995 255.995"
    >
      <g
        fill="none"
        strokeMiterlimit="10"
        fontFamily="none"
        fontSize="none"
        fontWeight="none"
        textAnchor="none"
        style={{ mixBlendMode: "normal" }}
      >
        <path
          fill="#47667f"
          d="M36 35.5C36 29.7 30.9 25 24.5 25S13 29.7 13 35.5 18.1 46 24.5 46 36 41.3 36 35.5z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#c5cad5"
          d="M35.5 35c0-5.3-4.9-9.6-11-9.6s-11 4.3-11 9.6 4.9 9.6 11 9.6 11-4.3 11-9.6z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#c5cad5"
          d="M5 10l19 11v22L6 30z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#6d83b3"
          d="M43 10L24 21v22l18-13z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#5a6e91"
          d="M24.5 44.6h.8l9.8-7.1c.2-.8.4-1.6.4-2.4v-.3L24 43l-10.5-7.6c.1 1 .3 2 .7 3l8.3 6c.7.1 1.3.2 2 .2z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#eaf4f8"
          d="M5 10l19 11 19-11-19-9z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#34495e"
          d="M11.6 9.9L24 17l12.4-7.1L24 4zM40 28l.6-12.9L27 23v14.4zM8 28l-.6-12.9L21 23v14.4z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#eaf4f8"
          d="M29.7 16.4l-3.1-2 1.7-3.8-4.6 1.6 1.7-3.7-7.7 2.5 3-4.1-1.9-1 .4-.8 3 1.4-1.9 2.6 6.8-2.3-1.5 3.7 4.6-1.6-2.3 5.1 2.4 1.6z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#ecf0f1"
          d="M28.8 27.4c.1.5-.5 2.8-.5 3.1 0 .3-.2.5-.5.6-.1-.9-.2-1.7-.3-2.6 0-.2.2-.3.4-.4.1.7.1 1.4.2 2.1 0 0 .3-1.5.4-2.3 0-.2.1-.4.3-.5zm10-5c-.1.3-.1.8-.5 1 0-.3.1-.5.2-.7.2-.4.2-.9 0-1.3-.1-.2.1-.3.2-.4.2-.1.1.2.3.2.2-.2.1-.6.4-.7.1.1 0 .2-.1.3-.2.5-.3 1 0 1.5.1.2 0 .3-.2.4 0 0-.1.1-.2-.1-.1 0-.1-.1-.1-.2zM29 30c0-.6.1-1.2.1-1.8 0-.2.1-.4.3-.4 0 .7-.1 1.4-.1 2.1 0 .2-.1.2-.2.3-.1 0-.1-.2-.1-.2zm.5-3.2c.2.1 0 .4 0 .5 0 .1-.1.2-.2.2s-.1-.1-.1-.2c-.1-.1.1-.6.3-.5zm-9.7 2.9c-.4-.3-.7-.5-1.2-.8.1.4.2.7.5.9.3.2.5.4.8.6.1.1.2.1.1.3-.1.2-.2.1-.3 0-.9-.5-1.4-1.2-1.5-2.2v-.3c0-.2 0-.5.3-.6.2-.1.4.1.5.2.2.2.5.3.7.5.1.1.2.2.1.3-.1.2-.2 0-.3 0-.2-.1-.3-.2-.5-.3-.1-.1-.4-.3-.4 0s0 .3.2.4c.3.2.6.4.9.7.2 0 .2 0 .1.3zm-1.5-.4c.1.1-.1.3-.2.2-.4-.3-.7-.5-1.1-.8-.2-.1-.2-.3-.2-.4-.1-.7-.1-1.4-.2-2.1 0-.1 0-.1.1-.1.1.1.2.2.2.3 0 .4.1.8.1 1.2.1.7.2.9.7 1.1l.6.6zm11.5.3c0-.7.1-1.4.1-2.1 0-.2 0-.2.3-.2.1 0 .2-.4.4-.5 0 .2 0 .4-.2.6-.2.2-.2.4-.2.6 0 .4-.1.7-.1 1.1.1.3 0 .4-.3.5zm5.5-4.3c-.1 0-.2 0-.1-.1 0-.5.1-2 .2-2.3 0-.1.1-.3-.1-.3-.1 0-.2.1-.2.2-.1.3-.3 2.8-.1 3.1.1.1.3-.3.3-.6zm-3.7.8s-.2.2-.2 0v-.5c-.2 0-.2.1-.2.3 0 .3 0 .5-.3.8 0 0-.1.2 0 .2.2.4.1.7.1 1.1 0 .2-.1.6.1.7.3.1.5-.6.5-.6-.2 0-.2-.3-.2-.5 0-.4-.1-.8.3-1.1 0-.1-.1-.2-.1-.4zm6-4.4c-.5.4-.6 1.1-.6 1.8 0 .3 0 .8.5.6.8-.4.7-1.3.7-2.1 0-.5-.2-.6-.6-.3zm-.1 1.8c-.1 0-.1-.3-.1-.4 0-.4.1-1.1.4-1.1.1 0 .1.1.1.2 0 .4-.1 1.3-.4 1.3zm-24.8 2.1c-.2-.1-.3-.2-.4-.4-.3-.5-.5-1-.8-1.5.3.2.7.4.8.3.2-.2-.2-.6-.3-.7-.2-.1-.4-.3-.7-.5 0 .3.1 1.3.1 1.7 0 .1.1.2-.1.2-.1 0-.2-.1-.2-.2-.1-.4-.3-2.3-.2-2.4.7.5 1.6.9 1.7 2 0 .4-.1.6-.5.6.1.3.3.5.4.8.2-.1.4 0 .2.1zm3.7 2.2c-.3-.2-.5-.4-.8-.6-.4-.4-.6-.9-.6-1.4 0-.3.2-.4.5-.2.2.1.4.3.6.4.1 0 .1.2.2 0 .1-.1.1-.2-.1-.3l-.9-.6c-.2-.1-.4-.2-.5.1-.2.7 0 1.3.3 1.9.3.5.7.7 1.1 1.1 0 0 .2.2.3 0 .1-.2.1-.3-.1-.4z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
        <path
          fill="#ecf0f1"
          d="M10.7 22.1c-.3-.6-1.4-1.2-1.4-1.3-.4-.3-.6-.2-.7.3 0 .4.1.7.2 1.1.2.8.8 1.2 1.4 1.6.5.3.7.2.7-.3.1-.5 0-1.2-.2-1.4zm-.1 1.2c-.1.1-.1.2-.3.1-.7-.2-1.4-1.1-1.4-1.9 0-.1 0-.3.1-.4.2-.1.3 0 .4.1.6.4 1.1.8 1.2 1.6.1.3.1.4 0 .5zm26.2.1c-.2-.3-.1-.6 0-.9 0-.1.2-.7-.3-.7-.3 0-.7.4-.7.7-.1.5-.2 2.8-.2 2.8.3-.2.6-.4.8-.7.3-.3.5-.8.4-1.2zm-.4.5c0 .3-.1.5-.4.7v-.7c0-.2.1-.3.3-.3.1 0 .1.2.1.3zm0-1.3c0 .2-.1.4-.4.6v-.7c0-.1.1-.2.2-.2.3.1.3.2.2.3zM33 25.1c-.3 0-.3.3-.3.4 0 0-.1 1.6-.1 1.7-.1.1-.1.2-.2.2s-.1-.2-.1-.3c0-.4 0-.7.1-1.1 0-.1.1-.4-.1-.3-.3 0-.3.3-.3.5 0 .5-.1.9-.1 1.4 0 .3.1.6.4.4.1-.1.3-.3.3-.5.4.1.3-.3.4-.5.1-.5.1-1 .1-1.5 0-.1 0-.3-.1-.4zm-18.8 0c-.1-.3-.3-.7-.4-1 0-.1-.1-.2-.2-.2s-.1.1-.2.2l-.6 1.6c0 .1.2.3.4.1.1-.1.3-1 .5-1.4l.5 1.3c-.3 0-.6-.4-.7-.3-.2.2.4.6.7.8.2.1.3.5.4.6 0 .1.2.4.4.2-.3-.6-.5-1.2-.8-1.9zm19.7-.8c-.6.4-.6.8-.4.8.1-.1.1-.2.2-.2.1-.1.2-.2.3-.1.1.1.1.3 0 .4l-.2.2c-.3.3-.5.8-.5 1.2 0 .1 0 .3.1.3s.2 0 .3-.1c.1-.2.3-.4.6-.5 0-.6.1-1.1.1-1.9 0-.3-.3-.2-.5-.1zm-.1 2h-.1c0-.3.1-.4.4-.6 0 .2-.1.4-.3.6z"
          transform="translate(-5.333 -5.333) scale(1.04167) translate(-.002 2.664) scale(5.33333)"
        ></path>
      </g>
    </svg>
  );
};

export default VirtualBoxIcon;
